module.exports = __webpack_public_path__ + "media/common/icon-weather-rainy-ab7121d0.svg";